export const mutations = {
  SET_SIDE_BAR_RECOMMENDATIONS(state, { experience, recommendations }) {
    if (experience === 'merch') {
      state.sideBarRecommendationsMerch = recommendations;
    } else if (experience === 'design') {
      state.sideBarRecommendationsDesign = recommendations;
    } else {
      state.sideBarRecommendationsDefault = recommendations;
    }
  }
};

export const getters = {
  sideBarRecommendations(store, getters, rootState, rootGetters) {
    if (rootGetters['experience/isMerchActive']) {
      return store.sideBarRecommendationsMerch;
    } else if (rootGetters['experience/isDesignActive']) {
      return store.sideBarRecommendationsDesign;
    } else {
      return store.sideBarRecommendationsDefault;
    }
  }
};

export const actions = {
  async LOAD_SIDE_BAR_RECOMMENDATIONS({ commit, state, rootGetters }) {
    try {
      const experience = rootGetters['experience/getExperience'];
      let isMerch = experience == 'merch';
      let isDesign = experience == 'design';
      let isMerchLoaded = state.sideBarRecommendationsMerch.length > 0;
      let isDesignLoaded = state.sideBarRecommendationsDesign.length > 0;
      let isDefaultLoaded = state.sideBarRecommendationsDefault.length > 0;
      const isDefault = !isMerch && !isDesign;
      if (
        (isDefault && !isDefaultLoaded) ||
        (isMerch && !isMerchLoaded) ||
        (isDesign && !isDesignLoaded)
      ) {
        const response = await this.$axios.get('recommendations/side_bar/');
        let recommendations = response.data.data;
        commit('SET_SIDE_BAR_RECOMMENDATIONS', { experience, recommendations });
      }
    } catch (error) {
      console.error('Recommendations | LOAD_SIDE_BAR_RECOMMENDATIONS:' + error);
    }
  }
};

export const state = () => ({
  sideBarRecommendationsMerch: [],
  sideBarRecommendationsDesign: [],
  sideBarRecommendationsDefault: []
});
